import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { Stock, Warehouse } from '../availability.service';
import { TranslocoDirective } from '@jsverse/transloco';
import { byKeyComparator } from '../../../../../helpers/array';
import { Store } from '../../../../stores-map/stores.service';

@Component({
  selector: 'app-showroom-availability',
  imports: [TranslocoDirective],
  templateUrl: './showroom-availability.component.html',
  styleUrls: ['./showroom-availability.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShowroomAvailabilityComponent {
  private _showroomStocks!: Store & Pick<Warehouse, 'stocks'>;

  availableSizes = signal('');

  @Input({ required: true })
  set showroomStocks(value: Store & Pick<Warehouse, 'stocks'>) {
    this._showroomStocks = value;
    this.availableSizes.set(this.createAvailableSizesString());
  }

  get showroomStocks(): Store & Pick<Warehouse, 'stocks'> {
    return this._showroomStocks;
  }

  private createAvailableSizesString(): string {
    return this.showroomStocks.stocks
      .sort(byKeyComparator<Stock>('size'))
      .reduce((acc, curr) => {
        if (curr.size) {
          acc += `${acc ? ', ' : ''}${curr.size}`;
        }

        return acc;
      }, '');
  }
}
